import axios from 'axios';

export default {
    list() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/monitoring-exports');
    },

    listAdminExports() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/monitoring-exports/admin-exports');
    },

    get(id) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/monitoring-exports/' + id);
    },

    favorite(id) {
        return axios.patch(process.env.VUE_APP_API_URI + '/api/monitoring-exports/' + id);
    },

    remove(id) {
        return axios.delete(process.env.VUE_APP_API_URI + '/api/monitoring-exports/' + id);
    },

    create(data) {
        return axios.post(process.env.VUE_APP_API_URI + '/api/monitoring-exports', data);
    },
}
